<template>
  <div class="container-fluid">
    <page-title
      :canDownload="false"
      :title="this.$t('areas')"
      iconClasses="fas fa-map-pin"
      :isTimelineDisplayed="true"
    />

    <!-- main container -->
    <div class="container-fluid area">
      <form-controls
        v-if="controlsConfig.length > 0"
        :controls="controlsConfig"
        :displayConfig="{}"
        v-on:setDefaultValues="setFormControlsDefault"
        v-on:updateControl="handleFormControlChange"
      />

      <!-- Charts list component-->
      <charts-list
        :chartsProp="charts"
        :downloaded="downloaded"
        :isDraggable="true"
        :period="period"
        type="areas"
        :area="formControl.area"
        :hierarchy="JSON.parse(JSON.stringify(hierarchy))[getCurrentUser.role.toLowerCase()]"
        v-on:createdChart="onChartCreate"
        v-on:deletedChart="onChartDelete"
        v-on:updatedChart="onChartUpdate"
        v-on:updateChartsRows="onUpdateChartsRows"
      />
    </div>
  </div>
</template>

<script>
import { utilsMixin } from '../utils/mixins'
import datePicker from 'vue-bootstrap-datetimepicker'
import moment from 'moment'
import dCharts from '../../src/assets/config/default_rows_areas'
import hierarchy from '../assets/config/areas_chart_hierarchy'

export default {
  name: 'Areas',
  mixins: [utilsMixin],
  props: ['period'],
  data() {
    return {
      hierarchy: hierarchy,
      datePicker: datePicker,
      timelineId: 'timeline',
      downloaded: true,
      timeout: null,
      config: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        locale: this.$locale,
      },
      isDataLoading: false,
      defaultCharts: dCharts,
      charts: [],
      formControl: {},
      controlsConfig: [],
    }
  },
  watch: {
    period: {
      handler: function() {
        this.updateCurrentUrl()
      },
      immediate: true,
    },
  },
  components: {
    'page-title': () => import('./utils/PageTitle'),
    'charts-list': () => import('./ChartsList'),
    'form-controls': () => import('./utils/FormControls'),
  },
  mounted() {
    if (this.isSiteParamValid()) {
      this.$set(this.formControl, 'site', String(this.$route.params.site))
    } else {
      this.$set(this.formControl, 'site', String(this.sitesWithMaps[0].id))
    }
    if (this.isAreaParamValid()) {
      this.$set(this.formControl, 'area', this.$route.params.area)
    }

    this.$emit('updateSite', [this.formControl.site])

    this.updateSiteIDFilter()
    this.$log.debug('created results', this.formControl)

    this.controlsConfig = this.generateControlsConfig()

    this.initializeCharts()
  },
  created() {
    this.updateSiteIDFilter()
    this.$log.debug('created results', this.formControl)
  },
  computed: {
    sitesWithMaps() {
      return this.getCurrentUser.sites.filter(site => site.has_map)
    },
    areas() {
      let areas = this.$i18n.messages[this.$locale].map_areas[this.formControl.site]
      this.$log.debug(
        'Areas',
        this.$i18n.messages[this.$locale].map_areas,
        this.formControl.site,
        areas,
      )
      return areas
    },
  },
  methods: {
    getSiteAreas(site) {
      return this.$i18n.messages[this.$i18n.locale].map_areas[site]
    },
    isSiteParamValid() {
      let foundSite = this.sitesWithMaps.find(site => {
        return site.site === this.$route.params.site
      })
      return this.$route.params.site && foundSite
    },
    isAreaParamValid() {
      if (
        this.isSiteParamValid() &&
        this.$route.params.area &&
        this.areas[this.$route.params.site] !== null
      ) {
        return true
      } else {
        return false
      }
    },
    initializeCharts() {
      let localCharts = JSON.parse(localStorage.getItem('areas-charts'))
      this.$log.debug('localCharts', localCharts)

      if (localCharts && Array.isArray(localCharts)) {
        this.charts = localCharts
        this.$log.debug('initializeCharts: foundLocalCharts', this.charts)
      } else {
        this.charts = this.defaultCharts
        localStorage.setItem('areas-charts', JSON.stringify(this.charts))
        this.$log.debug('initializeCharts: didntFoundLocalCharts', this.charts)
      }

      this.updateSiteIDFilter()
    },
    handleFormControlChange(config) {
      if (this.formControl[config.vModel] !== config.value) {
        this.formControl[config.vModel] = config.value

        if (config.vModel === 'site') {
          this.$emit('updateSite', [this.formControl.site])
        }

        this.$log.debug('handleFormControlChange', this.formControl[config.vModel])

        this.controlsConfig = this.generateControlsConfig()

        this.updateSiteIDFilter()
        this.updateCurrentUrl()
      }
    },
    updateCurrentUrl() {
      this.start = moment(this.period[0], this.dateFormat).format('YYYY-MM-DD')

      this.end = moment(this.period[1], this.dateFormat).format('YYYY-MM-DD')

      if (this.formControl.site) {
        window.history.pushState(
          null,
          null,
          '/areas/site/' +
            this.formControl.site +
            '/area/' +
            this.formControl.area +
            '/start/' +
            this.start +
            '/end/' +
            this.end,
        )
      }

      //window.location.reload()

      setTimeout(() => {
        this.charts = JSON.parse(JSON.stringify(this.charts))
      }, 300)
      //
    },
    updateSiteIDFilter() {
      this.charts.forEach(chart => {
        if (!chart.filters) {
          chart['filters'] = []
        }

        let siteIDFilter = chart.filters.find(filter => {
          return filter.type === 'site'
        })

        this.$log.debug('updateSiteIDFilter', chart.id, siteIDFilter)

        if (siteIDFilter) {
          siteIDFilter['values'] = [this.formControl.site]
        } else {
          siteIDFilter = {
            type: 'site',
            values: [this.formControl.site],
          }
          chart.filters.push(siteIDFilter)
        }
      })
    },

    onChartCreate(chart) {
      let localCharts = JSON.parse(localStorage.getItem('areas-charts'))
      localCharts.push(chart)
      localStorage.setItem('areas-charts', JSON.stringify(localCharts))
    },
    onChartDelete(id) {
      let localCharts = JSON.parse(localStorage.getItem('areas-charts'))
      let index = localCharts.findIndex(c => (c.id = id))
      localCharts.splice(index, 1)

      localStorage.setItem('areas-charts', JSON.stringify(localCharts))
    },
    onChartUpdate(chart) {
      let localCharts = JSON.parse(localStorage.getItem('areas-charts'))
      let index = localCharts.findIndex(c => (c.id = chart.id))
      localCharts[index] = chart

      localStorage.setItem('areas-charts', JSON.stringify(localCharts))
    },
    onUpdateChartsRows(charts) {
      if (charts) {
        charts = charts.filter(chart => {
          return chart.type != 'empty'
        })
        localStorage.setItem('areas-charts', JSON.stringify(charts))
      }
    },
    generateControlsConfig() {
      return [
        {
          type: 'select',
          vModel: 'site',
          default: this.isSiteParamValid() ? this.$route.params.site : this.sitesWithMaps[0].id,
          options: this.sitesWithMaps.map(site => ({ value: site.id, label: site.name })),
        },
        {
          type: 'select',
          vModel: 'area',
          default: this.$route.params.area ? this.$route.params.area : Object.keys(this.areas)[0],
          options: Object.keys(this.areas).map(key => ({
            value: key,
            label: this.areas[key],
          })),
        },
      ]
    },
  },
}
</script>
